import { render, staticRenderFns } from "./cImagePreview.vue?vue&type=template&id=40677073&scoped=true"
import script from "./cImagePreview.vue?vue&type=script&lang=js"
export * from "./cImagePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40677073",
  null
  
)

export default component.exports